import React from 'react'

import {ButtonBox, ProgressBox, ProgressTextBox, Text, Title} from './styles'
import {Button} from '../../../components/button'
import { useAppDispatch } from '../../../redux/configureStore'
import { useAuth } from '../../../components/AuthProvider'
import { trackReferralsProgramClick } from '../../../redux/members'

const View = () => {
  const auth = useAuth()
  const dispatch = useAppDispatch()

  return (
    <ProgressBox>
      <ProgressTextBox>
        <Title>Refer Friends, Get $50!</Title>
        <Text margin={'first'}>
          For every friend you refer who signs up for a membership:
        </Text>
        <Text $isSubItem={true} margin={'second'}>
          • We’ll give you $50 in your gift card of choice
        </Text>
        <Text $isSubItem={true}>
          • We’ll give them 15% off their subscription
        </Text>
        <Text margin={'second'}>
          Will send you a personalized discount code to share with your friends!
        </Text>
        <ButtonBox>
          <Button
            color="secondary"
            children="Participate Now"
            onClick={() => {
              if (auth.isAuthenticated) {
                dispatch(trackReferralsProgramClick({auth}))
              }

              window.open('https://www.blackspectacles.com/referral')
            }}
          />
        </ButtonBox>
      </ProgressTextBox>
    </ProgressBox>
  )
}

export default View
